export default "__VITE_ASSET__BSNT4atD__"